export const WorkOrderRequestTypes = {
    GET_WORK_ORDER_REQUEST_CUSTOMERS: "GET_WORK_ORDER_REQUEST_CUSTOMERS",
    CLEAR_WORK_ORDER_REQUEST_CUSTOMERS : "CLEAR_WORK_ORDER_REQUEST_CUSTOMERS",
    GET_WORK_ORDER_REQUEST_LIST : "GET_WORK_ORDER_REQUEST_LIST",
    CLEAR_WORK_ORDER_REQUEST_LIST : "CLEAR_WORK_ORDER_REQUEST_LIST",


}